import React, { useState, useEffect, forwardRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { registerMentionBlot } from '@/utils/quillMentionBlot';
import { registerVideoEmbed } from '@/utils/quillVideoEmbed';

// Registrar os Blots customizados
registerMentionBlot();
registerVideoEmbed();

interface QuillEditorProps extends React.ComponentProps<typeof ReactQuill> {
  className?: string;
}

const QuillEditor = forwardRef<ReactQuill, QuillEditorProps>((props, ref) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) {
    return (
      <div className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-500">
        Carregando editor...
      </div>
    );
  }

  return <ReactQuill ref={ref} {...props} />;
});

QuillEditor.displayName = 'QuillEditor';

export default QuillEditor;
